import React, { useEffect, useRef } from "react";
import { Divider, Empty } from "antd";
import Option from "./Option";
import { FlexibleSelectListProps, FlexibleSelectData } from "./type";
import { useMap } from "ahooks";
import { observer } from "mobx-react-lite";
import { uuid } from "@/utils";
import useLinkVirtualList from "./useLinkVirtualList";
import classNames from "classnames";
import FlexibleSelectHeader from "./FlexibleSelectHeader";
import FlexibleSelectFooter from "./FlexibleSelectFooter";

const FlexibleSelectList: React.FC<FlexibleSelectListProps> = function (props) {
    const {
        data,
        onChange,
        onSearch,
        multipleValue,
        itemHeight = 25 + 3,
        className,
        onSelectAllChange,
        preventComputed,
        onPreventComputed,
        needSimpleTitle,
        needSkuSimpleTitle,
        onSkuSimpleTitleChange,
        searchText,
        isIndeterminate,
        isSelectAll,
        multiple,
        type,

        onMultipleChange,
        shopId,
        onSimpleTitleChange,
        enabledTopSellingProductPrinting,
        onEnabledTopSellingProductPrintingChange,
        showTitlePic,
        onShowTitlePicChange,
    } = props;
    const [, { set, get, reset }] = useMap<string, boolean>(new Map());

    function handleCheck(d: FlexibleSelectData, checked: boolean, index: number) {
        set(d.value, checked);

        if (onChange) {
            onChange(d, checked, index);
        }
    }

    useEffect(() => {
        reset();

        multipleValue?.forEach((value) => {
            set(value, true);
        });
    }, [multipleValue]);

    const id = useRef(uuid()).current;

    const { list, containerProps, wrapperProps, containerWidth } = useLinkVirtualList(
        data,
        id,
        itemHeight,
        preventComputed,
        needSimpleTitle,
        needSkuSimpleTitle,
        showTitlePic,
    );

    return (
        <div
            className={classNames("container", className)}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <FlexibleSelectHeader
                data={data}
                multipleValue={multipleValue}
                multiple={multiple}
                isSelectAll={isSelectAll}
                isIndeterminate={isIndeterminate}
                onSelectAllChange={onSelectAllChange}
                onPreventComputed={onPreventComputed}
                onSearch={onSearch}
                searchText={searchText}
            />

            <Divider style={{ margin: 0 }} />

            <div
                {...containerProps}
                style={{ ...containerProps.style, width: containerWidth || undefined }}
                className="list-container"
                id={id}
            >
                {list?.length ? (
                    <ul {...wrapperProps} className="list-wrapper">
                        {list?.map((d, index) => {
                            const realData = d.data;
                            const value = d.data.value;

                            return (
                                <Option
                                    data={realData}
                                    isActive={multiple && get(value)}
                                    onCheck={handleCheck}
                                    key={value}
                                    index={index}
                                    /** ItemHeight包括marginBottom，需要减去marginBottom  */
                                    optionHeight={itemHeight - 3}
                                />
                            );
                        })}
                    </ul>
                ) : (
                    <div className="tc p10">
                        <p>没有匹配结果</p>
                        <p>
                            试试按<span className="error">【回车】</span>或
                            <span className="error ml3">点击【搜索】</span>
                            直接搜一下
                        </p>
                    </div>
                )}
            </div>

            <Divider style={{ margin: 0 }} />

            <FlexibleSelectFooter
                type={type}
                multiple={multiple}
                onMultipleChange={onMultipleChange}
                shopId={shopId}
                onSimpleTitleChange={onSimpleTitleChange}
                needSimpleTitle={needSimpleTitle}
                enabledTopSellingProductPrinting={enabledTopSellingProductPrinting}
                onEnabledTopSellingProductPrintingChange={onEnabledTopSellingProductPrintingChange}
                needSkuSimpleTitle={needSkuSimpleTitle}
                onSkuSimpleTitleChange={onSkuSimpleTitleChange}
                showTitlePic={showTitlePic}
                onShowTitlePicChange={onShowTitlePicChange}
            />
        </div>
    );
};

export default observer(FlexibleSelectList);
